export default __webpack_public_path__ + "a61060a2d64dcac5620ff58df025ed08.png";